import {
  Button,
  Divider,
  Form,
  InputNumber,
  Modal,
  Space,
  Typography,
} from "antd";
import moment from "moment";
// import axios from "axios";
import React, { useContext } from "react";
// import TextArea from "antd/es/input/TextArea";
// import { NotificationInfo, UserInfo } from "../../../../../context";

const CashierSummary = ({ open, close, selectedData }) => {
  //   const { userData } = useContext(UserInfo);
  //   const { rerunNotif } = useContext(NotificationInfo);

  //   const handleAddCashCountExpense = (values) => {
  //     const formdata = new FormData();
  //     formdata.append("user_id", userData.data.id);
  //     formdata.append("cash_count_id", selectedData.id);
  //     for (const name in values) {
  //       formdata.append(name, values[name]);
  //     }
  //     axios
  //       .post("user/merchant-employee/create/cash-count-expense", formdata)
  //       .then((response) => {
  //         const data = response.data;
  //         if (data === "success") {
  //           rerunNotif("success", "Created expense successfully.");
  //           setTimeout(() => {
  //             close();
  //             rerun();
  //           }, 1000);
  //         }
  //       })
  //       .catch((error) => {
  //         console.log("Error: ", error);
  //       });
  //   };

  return (
    <Modal
      title=""
      open={open}
      onCancel={() => close()}
      //   closable={false}
      footer={null}
      width={350}
      centered
    >
      <div style={{ display: "flex", gap: 10 }}>
        <div>
          <Typography>Date Shift:</Typography>
          <Typography>Petty Cash:</Typography>
          <Typography>Total Sales:</Typography>
          <Typography>Total Expense:</Typography>
          <Typography>Total Cash Count:</Typography>
        </div>
        <div>
          <Typography>
            {moment(`${selectedData.created_at.replace(" ", "T")}`)
              .utc()
              .format("MMM DD, YYYY")}
          </Typography>
          <Typography>
            {parseFloat(selectedData.cf_total).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </Typography>
          <Typography>
            {parseFloat(selectedData.daily_sales).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </Typography>
          <Typography>
            {parseFloat(selectedData.daily_expense).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </Typography>
          <Typography>
            {parseFloat(selectedData.g_total).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </Typography>
        </div>
      </div>
      <Divider />
      <Typography style={{ fontStyle: "italic" }}>Breakdown:</Typography>
      <div style={{ display: "flex", gap: 10 }}>
        <div>
          <Typography style={{ fontStyle: "italic" }}>Cash</Typography>
          <Typography style={{ fontStyle: "italic" }}>Non-Cash</Typography>
          <Typography style={{ fontStyle: "italic", marginLeft: 20 }}>
            Gcash
          </Typography>
          <Typography style={{ fontStyle: "italic", marginLeft: 20 }}>
            Gcredit
          </Typography>
          <Typography style={{ fontStyle: "italic", marginLeft: 20 }}>
            Paymaya
          </Typography>
          <Typography style={{ fontStyle: "italic", marginLeft: 20 }}>
            Credit Card
          </Typography>
          <Typography style={{ fontStyle: "italic", marginLeft: 20 }}>
            Debit Card
          </Typography>
          <Typography style={{ fontStyle: "italic", marginLeft: 20 }}>
            Bank Transfer
          </Typography>
          <Typography style={{ fontStyle: "italic", marginLeft: 20 }}>
            Cheque
          </Typography>
        </div>
        <div>
          <Typography>
            {parseFloat(selectedData.cash).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </Typography>
          <Typography>
            {parseFloat(selectedData.ecash).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </Typography>
          <Typography>
            {parseFloat(selectedData.gcash).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </Typography>
          <Typography>
            {parseFloat(selectedData.gcredit).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </Typography>
          <Typography>
            {parseFloat(selectedData.paymaya).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </Typography>
          <Typography>
            {parseFloat(selectedData.creditcard).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </Typography>
          <Typography>
            {parseFloat(selectedData.debitcard).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </Typography>
          <Typography>
            {parseFloat(selectedData.banktransfer).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </Typography>
          <Typography>
            {parseFloat(selectedData.cheque).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </Typography>
        </div>
      </div>
      <div style={{ marginTop: 20 }}>
        <div>
          <Typography style={{ fontStyle: "italic" }}>Formula:</Typography>
          <Typography style={{ fontStyle: "italic", fontWeight: "bold" }}>
            Petty Cash + Total Sales(In Cash) - Expense = Total Cash Count
          </Typography>
        </div>
      </div>
      <div style={{ marginTop: 20 }}>
        <div>
          <Typography style={{ fontStyle: "italic" }}>Summary:</Typography>
          <Typography style={{ fontStyle: "italic", fontWeight: "bold" }}>
            {selectedData.g_total === "0.00"
              ? "Waiting"
              : parseFloat(
                  parseFloat(selectedData.cf_total) +
                    parseFloat(selectedData.cash) -
                    parseFloat(selectedData.daily_expense)
                ) === parseFloat(selectedData.g_total)
              ? "Exact"
              : parseFloat(selectedData.g_total) >
                parseFloat(
                  parseFloat(selectedData.cf_total) +
                    parseFloat(selectedData.cash) -
                    parseFloat(selectedData.daily_expense)
                )
              ? "Over"
              : `Short - ${parseFloat(
                  parseFloat(
                    parseFloat(selectedData.cf_total) +
                      parseFloat(selectedData.cash) -
                      parseFloat(selectedData.daily_expense)
                  ) - parseFloat(selectedData.g_total)
                ).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}`}
          </Typography>
        </div>
      </div>
    </Modal>
  );
};

export default CashierSummary;
